import { makeAutoObservable } from 'mobx'
import { SingletonRequest } from 'shared/api/lib'

class CacheStore {
  constructor() {
    makeAutoObservable(this)
  }

  private dataMap: Map<string, unknown> = new Map()
  setData = <T>(key: string, data: T) => {
    this.dataMap.set(key, data)
  }
  getData = <T>(key: string): T | undefined => {
    return this.dataMap.get(key) as T
  }

  private _singletonData = new WeakMap()

  getSingletonData = <T, P>(...props: ConstructorParameters<typeof SingletonRequest<T, P>>) => {
    const request = new SingletonRequest<T, P>(...props).request
    type RES = typeof request
    if (!this._singletonData.has(props[0])) {
      this._singletonData.set(props[0], request)
    }
    return this._singletonData.get(props[0]) as RES
  }
}

export const cacheStore = new CacheStore()
